/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AttachmentVO, BaseAttachmentDTO } from '@well/attachment/domain';
import { Subject } from 'rxjs';
import {CommonModule} from "@angular/common";
import {TooltipModule} from "primeng/tooltip";
import {ButtonModule} from "primeng/button";
import {TranslateModule} from "@ngx-translate/core";
import { AttachmentListItemComponent } from '../attachment-list-item/attachment-list-item.component';

@Component({
  selector: 'well-attachment-list',
  templateUrl: './attachment-list.component.html',
  styleUrls: ['./attachment-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TooltipModule,
    ButtonModule,
    TranslateModule,
    AttachmentListItemComponent
  ],
})
export class AttachmentListComponent {
  @Input() attachments: BaseAttachmentDTO[] | AttachmentVO[] | undefined = undefined;
  @Input() canDelete = false;
  @Input() canSync = false;

  @Output() delete: Subject<string> = new Subject<string>();
  @Output() sync = new EventEmitter<string>();

  onDelete(uuid: string) {
    this.delete.next(uuid);
  }

  onSync(uuid: string) {
    this.sync.emit(uuid);
  }
}
